import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Pipe({
  name: 'safe',
})
export class SafePipe implements PipeTransform {
  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(url: string | null | undefined): SafeResourceUrl | '' {
    if (!url || typeof url !== 'string') {
      return '';
    }

    const trimmedUrl = url.trim();
    // Valide que l'URL commence uniquement par https://, http:// ou // pour éviter tout schéma dangereux (ex. javascript:)
    if (!/^(https?:|\/\/)/i.test(trimmedUrl)) {
      return '';
    }

    // L'URL est strictement validée ci-dessus (uniquement protocoles HTTP/HTTPS sûrs autorisés pour les iframes de visite virtuelle)
    return this.sanitizer.bypassSecurityTrustResourceUrl(trimmedUrl); // NOSONAR
  }
}
